import ProductCard from './ProductCard';
import React, { useState, useContext } from 'react';
import { PlanoContext } from './PlanoContext';
import { useDrop } from 'react-dnd';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Box,
  Typography,
  Paper,
  Stack,
  alpha,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import GridViewIcon from '@mui/icons-material/GridView';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function ProductList({
  cates,
  handleSave,
  laneLength,
  search,
  setSearch,
  TCN,
  setProds,
  toggleBox,
  setBoxes,
  rows,
  columns,
  setRows,
  setColumns,
  url,
}) {
  const theme = useTheme();
  const { prods, error, setError, dragProd, setDragProd } = useContext(PlanoContext);

  const [cate, setCate] = useState('All Categories');
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggleBox = () => {
    setIsCollapsed(!isCollapsed);
    toggleBox(); // 调用原来的toggleBox函数
  };

  const generateBoxes = () => {
    const newBoxes = {
      rows,
      columns,
      boxes: [],
      floors: [],
    };
    let floors = [];

    for (let i = 0; i < rows; i++) {
      floors.push({
        row: i + 1,
      });
    }

    floors.forEach((element, idx) => {
      element.lines = [];
      for (let i = 0; i < columns; i++) {
        element.lines.push({
          id: `${i + 1}-${idx + 1}`,
          row: idx + 1,
          column: i + 1,
          borrowed: false,
          rent: false,
          product: null,
          disabled: false,
          useForLink: false,
          type: '0',
          linkArray: [],
        });
      }
    });
    setBoxes({ rows, columns, floors });
    console.log('newBoxes', { rows, columns, floors });
    // setBoxes(newBoxes?.boxes);
  };
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ['planogramProduct', 'boxProduct'],
    drop: (item, monitor) => {
      if (monitor.getItemType() === 'boxProduct') {
        console.log('Product removed from box and returned to product list');
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  let newProds = prods.filter((val) => {
    let c1 = val?.category?.map((e) => e.name);
    if (search == '') {
      if (cate == 'All Categories') {
        return val;
      } else if (c1?.length > 0 && c1.join(', ').toLowerCase().includes(cate.toLowerCase())) {
        return val;
      }
    } else if (val.name.toLowerCase().includes(search.toLowerCase())) {
      if (cate == 'All Categories') {
        return val;
      } else if (c1?.length > 0 && c1.join(', ').toLowerCase().includes(cate.toLowerCase())) {
        return val;
      }
    }
    // }
  });

  // newProds.filter((val) => {
  //   // console.log(val);
  //   console.log('dgprod', dragProd);
  //   if (val.name === dragProd) {
  //     console.log(val.name);
  //     return val;
  //   }
  // });

  return (
    <Box
      className="Plano-Products"
      ref={drop}
      sx={{ position: 'relative', maxWidth: '460px', width: '100%' }}
    >
      {/* Drop zone indicator when dragging from box */}
      {isOver && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: alpha('#ff6b6b', 0.3),
            border: '3px dashed #ff6b6b',
            borderRadius: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            pointerEvents: 'none',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 3,
              borderRadius: 3,
              textAlign: 'center',
              border: '2px solid #ff6b6b',
            }}
          >
            <Stack spacing={1} alignItems="center">
              <DeleteOutlineIcon sx={{ fontSize: 48, color: '#ff4757' }} />
              <Typography variant="h6" sx={{ color: '#ff4757', fontWeight: 700 }}>
                Remove Product
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Drop here to remove from planogram
              </Typography>
            </Stack>
          </Paper>
        </Box>
      )}

      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          ml: 2,
          mr: 1,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: 2.5,
            background: `linear-gradient(135deg, ${alpha(
              theme.palette.primary.main,
              0.08
            )} 0%, ${alpha(theme.palette.secondary.main, 0.08)} 100%)`,
            borderBottom: `2px solid ${theme.palette.primary.main}`,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
            Products List
          </Typography>
        </Box>

        {/* Search and Filter */}
        <Box sx={{ p: 2.5 }}>
          <Stack spacing={2}>
            <TextField
              onChange={(event) => {
                setSearch(event.target.value);
              }}
              fullWidth
              label="Search..."
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  '& fieldset': {
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                  },
                  '&:hover fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main,
                    borderWidth: 2,
                  },
                },
              }}
            />
            <FormControl fullWidth>
              <InputLabel id="category-select-label">Category</InputLabel>
              <Select
                labelId="category-select-label"
                id="category-select"
                value={cate}
                label="Category"
                onChange={(event) => {
                  setCate(event.target.value);
                }}
                sx={{
                  borderRadius: 2,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                    borderWidth: 2,
                  },
                }}
              >
                <MenuItem value="All Categories">All Categories</MenuItem>
                {cates.map((item, i) => (
                  <MenuItem key={i} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>

        {/* Products List */}
        <Box className={`plano-scrollable ${isCollapsed ? 'collapsed' : ''}`} sx={{ px: 2.5 }}>
          {newProds.map((prod, i) => (
            <ProductCard
              newProds={newProds}
              i={i}
              newURL={url}
              TCN={TCN}
              url={`${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}?quality=10`}
              error={error}
              setError={setError}
              prod={prod}
              key={i}
              laneLength={laneLength}
              setProds={setProds}
            />
          ))}
        </Box>

        {/* Action Buttons */}
        <Box sx={{ p: 2.5 }}>
          <Stack spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              startIcon={<SaveIcon />}
              fullWidth
              sx={{
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 700,
                fontSize: '1rem',
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                transition: 'all 0.3s ease',
              }}
            >
              Save My Planogram
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleToggleBox}
              startIcon={isCollapsed ? <ViewModuleIcon /> : <GridViewIcon />}
              fullWidth
              sx={{
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '1rem',
                borderWidth: 1.5,
                '&:hover': {
                  borderWidth: 1.5,
                  backgroundColor: alpha(theme.palette.primary.main, 0.08),
                },
              }}
            >
              {isCollapsed ? 'Planogram' : 'Locker Box'}
            </Button>
          </Stack>
        </Box>

        {/* Box Configuration */}
        {isCollapsed && (
          <Box sx={{ p: 2.5, pt: 0 }}>
            <Paper
              elevation={0}
              sx={{
                p: 2.5,
                borderRadius: 2,
                background: alpha(theme.palette.primary.main, 0.05),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    label="Columns"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setColumns(parseInt(e.target.value))}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    label="Rows"
                    variant="outlined"
                    fullWidth
                    onChange={(e) => setRows(parseInt(e.target.value))}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={generateBoxes}
                    fullWidth
                    startIcon={<GridViewIcon />}
                    sx={{
                      py: 1.5,
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 600,
                    }}
                  >
                    Generate Boxes
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        )}
      </Paper>
    </Box>
  );
}
